/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { get_candidate_assessment_response_data_action } from "../../../../redux/_actions";

function useAssessmentVideos() {
  const [assessmentKitQuestionsVideos, setAssessmentKitQuestionsVideos] =
    useState();
  const [expandKitLoading, setExpandKitLoading] = useState();
  const [expandedAssessmentKitId, setExpandedAssessmentKitId] = useState(null);

  const dispatch = useDispatch();
  const { candidateResponseData } = useSelector(
    (state) => state.get_candidate_assessment_response_reducer
  );
  const { userPublicProfileData } = useSelector(
    (state) => state.get_user_public_profile_data_reducer
  );

  useEffect(() => {
    if (candidateResponseData) {
      setAssessmentKitQuestionsVideos(
        candidateResponseData
      );
    }
  }, [candidateResponseData]);

  const onAssessmentKitExpandClick = async (id) => {
    if (expandedAssessmentKitId !== id) {
      setExpandKitLoading(true);
      setExpandedAssessmentKitId(id);
      if (userPublicProfileData?.data) {
        const candidateId = userPublicProfileData.data?.user;
        await dispatch(
          get_candidate_assessment_response_data_action(id, candidateId)
        );
      }
      setExpandKitLoading(false);
    }
  };
  return {
    expandedAssessmentKitId,
    assessmentKitQuestionsVideos,
    onAssessmentKitExpandClick,
    expandKitLoading,
  };
}

export default useAssessmentVideos;
